/// <amd-module name="typeahead/core/logging/TypeaheadInteractionLogger" />

import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {SuggestionEngagementLogger} from "typeahead/core/logging/SuggestionEngagementLogger";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";
import {TypeaheadInteractionMetric} from "typeahead/core/logging/TypeaheadInteractionMetric";

export class TypeaheadInteractionLogger extends SuggestionEngagementLogger {

    constructor() {
        super();
    }

    protected emitMetric(): void {
        this.updatePackageType();
        this.removeDuplicateESSTests();
        let metric: any = new TypeaheadInteractionMetric(this.lob, this.domElementId, this.userTypedQuery,
            this.isSuggestionShown, this.selectedSuggestion,
            this.childSuggestionsExpanded, this.areChildrenPresent, this.activeESSTests.join("|"));
        metric = this.cleanUpMetric(metric);
        TypeaheadErrorLogger.log(undefined, undefined, ProblemOrigin.TypeaheadInteractionMetric, metric);
    }

    private cleanUpMetric(metric: any) {
        const cleanMetric: any = {};
        Object.keys(metric).forEach((key) => {
            if (key && metric[key] !== undefined) {
                cleanMetric[key] = metric[key].toString();
            }
        });
        return cleanMetric;
    }
}
